 
import React, { Component } from 'react';
import PropTypes from 'prop-types';


const Loading  = () => (<h3 className="pagina" style={{textAlign: "center"}}>Carregando</h3>);

class ComponenteAsync extends Component {
  static propTypes = {
    load: PropTypes.func.isRequired,
  };

  state = {
    LoadedComponent: null,
  };

  componentWillMount() {
    this.load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.load !== this.props.load) {
      this.load(nextProps);
    }
  }

  load(props) {
    this.setState({
      LoadedComponent: null,
    });

    props.load().then(mod => {
      this.setState({
        LoadedComponent: mod.default ? mod.default : mod,
      });
    });
  }

  render() {
    const { LoadedComponent } = this.state;

    return LoadedComponent ? <LoadedComponent {...this.props} /> : <Loading />;
  }
}

export default ComponenteAsync;
 



// WEBPACK FOOTER //
// ./src/components/componente-async.jsx